export default __webpack_public_path__ + "static/media/red-river-technology-logo.bc7ea373.png";